import ApplicationController from './application_controller'

export default class extends ApplicationController {

	connect() {
		const firstElement = document.querySelectorAll('[data-controller="scroll-to"]')[0]
		if (firstElement == this.element) {
			const elementY = this.element.getBoundingClientRect().y
			const scrollToY = window.pageYOffset + elementY
			window.scrollTo(0, scrollToY - 16)
		}
	}

}
